module.exports = __webpack_public_path__ + "img/video-outlined.0aba7140.svg";